import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>February Wine Dinner</h1>
                <h2 className={classes.bold}>
                  February 4th <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $55 Per Guest
                </h2>
                <h3>Featuring Sean Minor Wines</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>
                <h5>First Course</h5>
                <h4>Smoked Salmon Rolls</h4>
                <p>Rolled with Cream Cheese, Dill, Capers, Cucumber, &amp; Red Onions · Topped with Dijon Mustard · Served on Crostinis</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Sean Minor · Sauvignon Blanc · California 2023</h4>
              </div>
 
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Curry Coconut Crab Cakes</h4>
                <p>Apricot Risotto, Ginger &amp; Apricot Aioli</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Sean Minor · Chardonnay · California 2023</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Braised Short Rib Porcini Marsala</h4>
                <p>Tossed with Garganelli Pasta</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Sean Minor · Cabernet Sauvignon · Paso Robles 2023</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>White Chocolate Cheesecake</h4>
                <p>Macerated Blackberries</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Sean Minor · Pinot Noir · California 2022</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner